exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gallery-container {\n  -ms-flex-line-pack: justify;\n      align-content: space-between;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: wrap;\n      flex-flow: wrap; }\n\n.gallery-item {\n  height: 200px;\n  margin: .5em 1em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/collection-module/view/gallery/gallery.component.scss
// module id = ../../../../../src/app/collection-module/view/gallery/gallery.component.scss
// module chunks = main